// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class MicrosoftApiService {
   $http: any
   $log: any
   $q: any
   $timeout: any
   authService: any
   fire: any
   i18n: any
   savedSearchConfigs: any
   scope: any
   writeChain: any
   maxWriteRetries: number
   writeRetryBackoffMs: number
   constructor(configs: any, store: any, i18n: any, hooksService: any, $q: any, $http: any, $log: any, authService: any, $timeout: any) {
      this.init = this.init.bind(this)
      this.loginSuccessHandler = this.loginSuccessHandler.bind(this)
      this.logoutSuccessHandler = this.logoutSuccessHandler.bind(this)
      this.getFileId = this.getFileId.bind(this)
      this.getFileContents = this.getFileContents.bind(this)
      this.writeToFile = this.writeToFile.bind(this)
      this.putFileContents = this.putFileContents.bind(this)
      this.isConflictError = this.isConflictError.bind(this)
      this.createGraphRequest = this.createGraphRequest.bind(this)
      this.createFileAndReturnId = this.createFileAndReturnId.bind(this)
      this.handleApiError = this.handleApiError.bind(this)
      this.i18n = i18n
      this.$q = $q
      this.$http = $http
      this.$log = $log
      this.authService = authService
      this.$timeout = $timeout
      // Writes are queued through this promise chain so only one full-file PUT is ever
      // in flight at a time (see writeToFile). A failed write does not break the queue.
      this.writeChain = this.$q.resolve()
      this.maxWriteRetries = 3
      this.writeRetryBackoffMs = 300
      this.savedSearchConfigs = configs.data.savedSearchAndItems
      this.scope = {
         name: 'Microsoft',
         userId: '',
         userDisplay: '',
         provider: 'microsoft',
         initialized: false,
         accessToken: null //TODO - check if this is updated correctly after a auth provider refresh - probably not
      }

      hooksService.setHooks(this, 'MicrosoftApiService', ['initSuccess', 'initFailed', 'signOut'])
   }

   init() {
      if (!this.savedSearchConfigs.providers.includes('microsoft')) {
         return
      }
      if (!this.authService.providerSupportsFeature('microsoft', 'cloudStorage')) { 
         return 
      }
      return this.scope.providerDisplayName = this.scope.name
   }

   loginSuccessHandler(event: any, args: any) {
      if (!this.savedSearchConfigs.providers.includes('microsoft')) {
         return
      }
      if (!this.authService.providerSupportsFeature(args.provider, 'cloudStorage') || (args.provider !== this.scope.provider)) {
         return
      }

      this.scope.userId = this.authService.scope.auth[this.scope.provider].user
      this.scope.accessToken = this.authService.scope.auth[this.scope.provider].accessToken
      this.scope.userDisplay = this.authService.scope.auth[this.scope.provider].username
      if (this.scope.accessToken && this.scope.userId) {
         this.scope.initialized = true
         return this.fire('initSuccess')
      } else { 
         this.$log.error('no accesstoken or userId found in response, cannot continue microsoft API integration')
         this.scope.initialized = false
         return this.fire('initFailed')
      }
   }

   logoutSuccessHandler(event: any, args: any) {
      if (args.provider !== this.scope.provider) {
         return
      }

      // remove save searches from session etc
      this.scope.userId = ''
      this.scope.userDisplay = ''
      this.scope.searches = []
      return this.fire('signOut')
   }

   getFileId(filename: any) {
      // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 1.
      return this.createGraphRequest('me/drive/special/approot:/' + filename )
         .then((resp: any) => {
            if (resp.status === 200) {
               return resp.data.id
            } else if (resp.status === 404) {
               return this.createFileAndReturnId(filename)
            } else {
               // @ts-expect-error TS(2304) FIXME: Cannot find name 'err'.
               return this.handleApiError(err)
            }
         }).catch((err: any) => {
            return this.handleApiError(err)
         })
   }

   getFileContents(fileId: any) {
      // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
      return this.createGraphRequest('me/drive/items/' + fileId, 'GET')
         .then((resp: any) => {
            const downloadUrl = resp.data["@microsoft.graph.downloadUrl"]
            return this.$http({url: downloadUrl})
               .then((resp: any) => {
                  return resp.data
               }).catch((err: any) => { throw err })
         }).catch(this.handleApiError)
   }

   // Writes the whole saved-items/searches file. Writes are serialized (one PUT in flight
   // at a time) so overlapping rapid saves/deletes — and the login-time dedup writeback —
   // cannot race and make OneDrive reject a write with `resourceModified` (an eTag
   // conflict), which previously dropped the write silently and left the cloud file out of
   // sync with the UI. A conflict originating from another tab/device is retried a bounded
   // number of times, because a full-file overwrite is idempotent from the UI's perspective.
   writeToFile(data: any, fileId: any) {
      this.writeChain = this.writeChain
         .catch(() => {}) // a previously failed write must not break the queue
         .then(() => this.putFileContents(data, fileId, 0))
      return this.writeChain
   }

   putFileContents(data: any, fileId: any, attempt: number): any {
      return this.createGraphRequest('me/drive/items/' + fileId + '/content', 'PUT', data)
         .catch((err: any) => {
            if (this.isConflictError(err) && attempt < this.maxWriteRetries) {
               // The file changed under us (a concurrent write from another tab/device).
               // Wait (exponential backoff) and retry the overwrite.
               return this.$timeout(
                  () => this.putFileContents(data, fileId, attempt + 1),
                  this.writeRetryBackoffMs * Math.pow(2, attempt)
               )
            }
            // createGraphRequest rejects with the raw $http response; the Graph error
            // payload lives under err.data ({ error: { code, message } }). Forward that so
            // handleApiError can format the real Graph code/message. Fall back to the
            // response itself for network errors, which carry a status but no data.
            return this.handleApiError(err?.data ?? err)
         })
   }

   // A concurrent-modification conflict from OneDrive: the Graph error code is
   // `resourceModified`, surfaced as HTTP 409 (also guard 412/423 lock variants).
   isConflictError(err: any) {
      const code = err?.error?.code ?? err?.data?.error?.code
      const status = err?.status
      return code === 'resourceModified' || status === 409 || status === 412 || status === 423
   }

   createGraphRequest(url: any, method: any, data: any) {
      const req = {
         method: (method != null) ? method : 'GET',
         url: 'https://graph.microsoft.com/v1.0/' + url,
         headers: {
            'Authorization' : 'Bearer ' + this.scope.accessToken, // TODO - we should do it server side I think... keep the token out of the users hands
            'Content-Type': 'application/json'
         }
      }

      // @ts-expect-error TS(2339) FIXME: Property 'data' does not exist on type '{ method: ... Remove this comment to see the full error message
      if (data) { req.data = data }

      return this.$http(req)
   }

   // creates the default Summon's app file to the user's drive account; returns a promise
   createFileAndReturnId(filename: any) {
      // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
      return this.createGraphRequest('me/drive/special/approot:/' + filename + ':/content?name.conflictBehavior=fail', 'PUT')
         .then((resp: any) => resp.data.id) // grabbing ID and outputting that to consumer
         .catch(this.handleApiError)
   }

   // use this to transform the response into a nice message which can be handled by code that uses this service.
   handleApiError(response: any) {
      const error = new Error()
      error.name = "microsoftApiService"
      if (response?.error == null) {
         error.message = response?.status === -1 ? this.i18n.translations.CLOUD_STORAGE_API_ERROR_NETWORK_ERROR : "Unknown"
         return this.$q.reject(error)
      }

      switch (response.error.code) {
         case 'cancelled':
         // override the message to make more sense for our users
            error.message = this.i18n.translations.CLOUD_STORAGE_AUTH_CANCELED
            break
         case 'invalid_session':
            error.message = this.i18n.translations.CLOUD_STORAGE_AUTH_ERROR
            break
         default:
            error.message = response.error.message + ' (' + response.error.code + ')'
      }

      this.$log.error(error)
      return this.$q.reject(error)
   }
}

MicrosoftApiService.$inject = ['configService', 'storeService', 'translationService', 'hooksService', '$q', '$http', '$log', 'authenticationService', '$timeout']

angular.module('summonApp.services')
   .service('microsoftApiService', MicrosoftApiService)
